<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Commodity Details</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr">
              <b-row class="align-items-end">
                <b-col md="5">
                  <b-row>
                    <!-- <md-input-container>
                      <label>Upload File</label>
                      <md-file
                        name="excelUpload"
                        id="excelUpload"
                        v-model="excelUpload"
                        @selected="onFileChange()"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      ></md-file>
                    </md-input-container> -->
                    <b-col>
                      <label>Item Name <span class="error">*</span></label>
                    <!-- </b-col>
                    <b-col > -->
                      <b-form-input
                        size="sm"
                        :formatter="capitalizeAll"
                        id="itemName"
                        name="itemName"
                        v-model="commodityModal.itemName"
                      ></b-form-input>
                      <span class="error" v-if="!commodityModal.itemName">{{
                        errorList.itemName
                      }}</span>
                      <!-- :state="!commodityModal.itemName?false:true" -->
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="5">
                  <b-row>
                    <b-col>
                      <label>HSN Code <span class="error"></span></label>
                    <!-- </b-col>
                    <b-col > -->
                      <b-form-input
                        size="sm"
                        :formatter="capitalizeAll"
                        id="hsnCode"
                        name="hsnCode"
                        v-model="commodityModal.hsnCode"
                      ></b-form-input>
                      <span class="error" v-if="!commodityModal.hsnCode">{{
                        errorList.hsnCode
                      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="2">
                  <b-button
                    style="margin-top: 0.3rem"
                    variant="primary"
                    @click="addCommodity"
                    id="addButtonLoader"
                    >{{
                      commodityModal.commodityNewId != "" ? "Update" : "Add"
                    }}</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loader"
                    style="display: none"
                  ></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="debounceSearch"
                        v-model="filter"
                        placeholder="Type to Search Item Name HSN Code"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          class="ml-2"
                          :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                          @click="getData('Excel')"
                          variant="outline-info"
                          > {{ ExcelBtnName }}
                          <b-spinner
                            v-if="ExcelBtnName != 'Export as Excel'"
                            small
                            label="Small Spinner"
                          ></b-spinner
                        ></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">

                    <h5 class="text-muted pull-right mt-2 ml-3">
                      <small v-if="isLoading == false"
                        >{{ totalRows }} Entries</small
                      >
                    </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="NewComodityMaster"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="sn" slot-scope="row0">
                    <span>{{
                      row0.index + 1 + (currentPage - 1) * perPage
                    }}</span>
                  </template>
                  <template slot="itemName" slot-scope="row1">
                    <!-- <span @click="editLocation(row1.item)" class="showMoreData"> -->
                    <span> {{ row1.item.itemName }}</span>
                  </template>
                  <template slot="action" slot-scope="row2">
                    <b-button
                      variant="outline-primary"
                      @click="editLocation(row2.item)"
                      id="addButtonLoader"
                      size="sm"
                      >Update</b-button
                    >
                  </template>
                  
                  <template slot="isCommodityActive" slot-scope="row3">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row3.item.commodityNewId">
                      <md-switch
                        :id="'approval' + row3.item.commodityNewId"
                        name="approval"
                        class="md-primary"
                        :value="row3.item.isCommodityActive == 1 ? true : false"
                        @change="activateUser(row3.item)"
                      >
                        <h6>
                          <br/>
                          <b-badge style="margin-left: -45px">{{
                            row3.item.isCommodityActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row3.item.commodityNewId">
                      <h6>
                        <b-badge>{{
                          row3.item.isCommodityActive == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </div>
                  </template>

                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/newcommodity");
      if (globalPermissionStatus("locaionMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("locaionMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }

      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      isLoading: false,
      fields: [
        {
          key: "sn",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "hsnCode",
          label: "HSN",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isCommodityActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      // excelUpload: "",
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: [
        "Please Enter ItemName",
        // "Please Enter HSNCode",
      ],
      errorList: {
        itemName: "",
        // hsnCode: "",
      },

      NewComodityMaster: [],
      validate: true,
      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData("Normal");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getData("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`NewCommodityMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.truckType();
        })
        .catch((err) => {
          throw err;
        });
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              // alert(data.find);

              if (
                data.commodityNewId != "" &&
                data.commodityNewId != undefined
              ) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.getData("Normal");
              console.log("MyData=>", data);
              console.log("Mystatus=>", status);
              this.$refs["addPop"].open();
              // Object.keys(this.commodityModal).map((x, index) => {
              //   this.commodityModal[x] = "";
              //   this.errorList[x] = "";
              // });
            }
          })
          .catch((error) => {});
      }
    },

    editLocation(item) {
      this.commodityModal.itemName = item.itemName;
      this.commodityModal.hsnCode = item.hsnCode;
      this.commodityModal.commodityNewId = item.commodityNewId;
      console.log(this.commodityModal);
    },

    getData(type) {
      let type_Size = {
        commodityModalTXT: "commodityModal",
        Param:'List',
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewCommodity_VP.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.NewComodityMaster = data.CommodityDetails;
            this.totalRows = data.CommodityDetails.length;

            if (type == "Excel") {
              if (data.CommodityDetails.length > 0) {
                this.NewComodityMaster = data.CommodityDetails;
                this.totalRows = data.CommodityDetails.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.CommodityDetails.length > 0) {
                this.NewComodityMaster = data.CommodityDetails;
                this.totalRows = data.CommodityDetails.length;
                console.log("Commodity Master List response=>", data);
              }
            }
          }
        })
        .catch((error) => {});
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.commodityNewId;

      this.itemObj.isCommodityActive = this.itemObj.isCommodityActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "commoditymaster_New",
        tableId: "commodityNewId",
        tableIsActive: "isCommodityActive",
        value1: this.itemObj.isCommodityActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData("Normal");
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}

</style>


// WEBPACK FOOTER //
// newcommodityMaster.vue?55bfe0cb